import http from 'hub-http/clients/apiClient';
export const updateCallNotes = (engagementId, payload) => {
  return http.put(`/engagements/v2/engagements/${engagementId}`, {
    data: payload
  }).then(updatedEngagement => {
    const updatedNotesHTML = updatedEngagement && updatedEngagement.properties && updatedEngagement.properties.hs_call_body && updatedEngagement.properties.hs_call_body.value;
    return updatedNotesHTML;
  });
};